import { Link } from "react-router-dom";
import logo from '../../assets/img/logo.png';

function Navbar() {
    return (
        <>
            <nav className="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">
                
                <Link to="/" className="navbar-brand d-flex align-items-center px-4 px-lg-5">
                   <img src={logo} width="60" height="50" alt="" /> &nbsp; <h4 className="m-0 text-primary"> KVB Alumni Portal</h4>
                </Link>
                <button type="button" className="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <div className="navbar-nav ms-auto p-4 p-lg-0">
                        <Link to={'/'} className="nav-item nav-link active">Home</Link>
                        <Link to={'/about'} className="nav-item nav-link">About</Link>
                        <Link to={'https://bhandaraof.kvs.ac.in/'} className="nav-item nav-link" target="_blank">School</Link>
                        {/* <div className="nav-item dropdown">
                            <Link to="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Pages</Link>
                            <div className="dropdown-menu fade-down m-0">
                                <Link to="#" className="dropdown-item">Our Team</Link>
                                <Link to="#" className="dropdown-item">Testimonial</Link>
                            </div>
                        </div> */}
                        <Link to="/events" className="nav-item nav-link">Events</Link>

                        <Link to="/contact" className="nav-item nav-link">Contact</Link>
                        <Link to="/membership_register" className="nav-item nav-link">Membership</Link>

                        <Link to="https://portal.kvbalumni.org" className="btn-login-nav">Login Now<i className="fa fa-arrow-right ms-3"></i></Link>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default Navbar;